import { render } from "./TableDropdown.vue?vue&type=template&id=894dd760&scoped=true&ts=true"
import script from "./TableDropdown.vue?vue&type=script&lang=ts"
export * from "./TableDropdown.vue?vue&type=script&lang=ts"

import "../assets/scss/table-dropdown.scss?vue&type=style&index=0&id=894dd760&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-894dd760"]])

export default __exports__